import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeSkillMapTrade = api(async function removeSkillMapTrade({ skillMapId, tradeId }) {
    return mutate(
        gql`
            mutation RemoveSkillMapTrade($skillMapId: String!, $tradeId: String!) {
                removeSkillMapTrade(skillMapId: $skillMapId, tradeId: $tradeId)
            }
        `,
        { skillMapId, tradeId },
        { returns: "removeSkillMapTrade" }
    )
})
